import { render, staticRenderFns } from "./ModalIncluirNovasProducoes.vue?vue&type=template&id=7c288c00"
import script from "./ModalIncluirNovasProducoes.vue?vue&type=script&lang=ts"
export * from "./ModalIncluirNovasProducoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports